var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('div',[_c('DaySelector',{on:{"select":_vm.select}})],1),_c('Table',{attrs:{"items":_vm.items,"orders":_vm.orders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }